import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';

// Design System - Custom CSS Variables & Utilities
import './assets/styles/variables.css';
import './assets/styles/global.css';
import './assets/styles/utilities.css';

import BootstrapVue3 from 'bootstrap-vue-3';

import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import BaseCard from "./components/ui/BaseCard.vue";
import BaseButton from "./components/ui/BaseButton.vue";
import BaseDialog from "./components/ui/BaseDialog.vue";
import ModernDialog from "./components/ui/ModernDialog.vue";
import ToastNotification from "./components/ui/ToastNotification.vue";

// Initialize Firebase messaging with store integration
import { initializeFirebaseMessaging } from "./components/firebase/firebase";

console.log('[Main.ts] 🚀 Starting app initialization...');

const app = createApp(App);

console.log('[Main.ts] 📦 Installing Vuex store...');
app.use(store).use(router);
app.use(BootstrapVue3);

console.log('[Main.ts] 🎨 Registering components...');
app.component('base-card',BaseCard);
app.component('base-button',BaseButton);
app.component('base-dialog',BaseDialog);
app.component('modern-dialog',ModernDialog);
app.component('toast-notification',ToastNotification);

// Initialize Firebase Cloud Messaging with Vuex store
// This enables FCM messages to trigger toast notifications
console.log('[Main.ts] 🔥 Initializing Firebase messaging...');

try {
  initializeFirebaseMessaging(store);
  console.log('[Main.ts] ✅ Firebase messaging initialized successfully');
} catch (error) {
  console.error('[Main.ts] ❌ Error initializing Firebase messaging:', error);
}

console.log('[Main.ts] 🎯 Mounting app...');
app.mount("#app");
console.log('[Main.ts] ✅ App mounted successfully');
